import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "main tw-text-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("h5", { class: "tw-text-[24px] tw-font-semibold tw-leading-[30px] tw-text-[#0c0f4a]" }, " Send Request? ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "tw-mt-[32px]" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "tw-text-[16px] tw-font-normal tw-leading-[24px] tw-text-black-50 tw-tracking-[0.15px]" }, " Are you sure you want to send you connection request to this contractor? ")
    ])
  ])
], -1)
const _hoisted_2 = { class: "tw-flex tw-items-center tw-gap-3" }

import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import Button from "@/core/components/ui/general/Button.vue";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UnSendTradeNetworkRequest',
  emits: ["on-cancel", "on-save"],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const loading = ref(false);
const onSave = () => {
  emits("on-save");
};
const onCloseModal = () => {
  emits("on-cancel");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GeneralDialog, {
    class: "tw-max-w-[450px]",
    onOnClose: onCloseModal,
    width: "100%",
    "max-width": "450px",
    borderRadius: "20px"
  }, {
    body: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Button, {
          variant: "tertiary",
          disabled: loading.value,
          label: "Cancel",
          onClick: onCloseModal,
          class: "!tw-w-[calc(50%-8px)] tw-max-w-full"
        }, null, 8, ["disabled"]),
        _createVNode(Button, {
          label: "Confirm",
          isLoading: loading.value,
          onClick: onSave,
          class: "!tw-w-[calc(50%-8px)] tw-max-w-full"
        }, null, 8, ["isLoading"])
      ])
    ]),
    _: 1
  }))
}
}

})